<template>
    <div class="overflow-hidden">

        <div id="velocity-form-animation" class="flex flex-col justify-center items-center overflow-hidden relative"
        >
            <div
                class="absolute text-center">
                <h2 class="text-6xl tracking-wide text-secondary-accent "
                    :class="buyingSentTextHidden ? 'opacity-0 hidden' : 'opacity-100'"
                >Sent</h2>
            </div>
            <div
                class="absolute text-center h-0 transition-opacity duration-1000
                       =flex justify-center items-center">
                <h2 class="absolute text-6xl tracking-wide text-remax-red mt-12"
                    :class="buyingFailTextHidden ? 'opacity-0' : 'opacity-100'"
                >Failed to Send</h2>
                <p class="text-xl"
                    :class="buyingFailTextHidden ? 'opacity-0' : 'opacity-100'"
                >{{ detailedErrorMessage }}</p>
            </div>
            <div
                class="absolute transition-opacity duration-1000
                       flex justify-center items-center"
                :class="buyingEnvelopeOpaque ? 'opacity-100' : 'opacity-0'"
            >
                <div id="envelope-bg" class=""></div>
                <div
                    class="envelope-container"
                    :class="{
                      'envelope-open': isBuyingEnvelopeOpen,
                      'envelope-flipped': isBuyingEnvelopeFlipped,
                      'envelope-slide': isBuyingEnvelopeSlid,
                      'slideRightFail': isBuyingEnvelopeSlidFail
                    }"
                >
                    <div class="flip-inner">
                        <div
                            class="envelope-back
                                   shadow-letter flex items-center justify-center
                                   transition-opacity duration-1000 text-center"
                        >
                            <div
                                class="buying-envelope-stamp transition-opacity duration-1000 sunburst-container"
                                :class="{
                                                                      'opacity-0': buyingEnvelopeStampOpaque,
                                                                      'opacity-100 stamped': !buyingEnvelopeStampOpaque,
                                                                      'blooming': buyingEnvelopeStampBlooming,
                                                                    }">
                                <img :src="stampSrc"
                                     class="sunburst-image max-w-16" alt="Stamp" />
                                <div class="line line-1"></div>
                                <div class="line line-2"></div>
                                <div class="line line-3"></div>
                                <div class="line line-4"></div>
                                <div class="line line-5"></div>
                                <div class="line line-6"></div>
                                <div class="line line-7"></div>
                                <div class="line line-8"></div>
                            </div>
                            <h5
                                class="text-xl font-base text-white tracking-wide
                                       transition-opacity duration-1000"
                                :class="buyingEnvelopeBackTextOpaque ? 'opacity-0' :
                                'opacity-100'"
                            >To: Gina Betbeze</h5>
                        </div>
                        <div class="envelope shadow-letter">
                            <div class="top">
                                <div class="outer "><div class="inner"></div></div>
                            </div>
                            <div class="bottom"></div>
                            <div class="left"></div>
                            <div class="right"></div>
                            <div class="cover"></div>
                            <div class="paper border-t-2 border-x-2 border-secondary-accent">
                                <h4 class="mt-2 text-2xl text-center">{{ paperTitle }}</h4>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div
                class="transition-opacity duration-500 w-full"
                :class="buyingFormOpaque ?  'opacity-0' : 'opacity-100'">
                <slot ></slot>
            </div>
        </div>
    </div>
</template>
<script setup>

const props = defineProps({
    paperTitle: {
        type: String,
        required: true,
    },
});
// Envelope animation stuff
import { ref } from "vue";

const buyingFormOpaque = ref(false);
const buyingEnvelopeOpaque = ref(false);
const isBuyingEnvelopeOpen  = ref(true);
const isBuyingEnvelopeFlipped = ref(false);
const buyingEnvelopeBackTextOpaque = ref(true);
const buyingEnvelopeStampOpaque = ref(true);
const buyingEnvelopeStampBlooming = ref(false);
const isBuyingEnvelopeSlid = ref(false);
const isBuyingEnvelopeSlidFail = ref(false);
const buyingSentTextHidden = ref(true);
const buyingFailTextHidden = ref(true);
const stampSrc = ref('');
const detailedErrorMessage = ref('');


// Function to toggle visibility
const toggleBuyingVisibility = () => {
    buyingFormOpaque.value = !buyingFormOpaque.value;
};
const toggleBuyingEnvelopeVisibility = () => {
    buyingEnvelopeOpaque.value = !buyingEnvelopeOpaque.value;
};
const toggleBuyingEnvelopeOpen = () => {
    isBuyingEnvelopeOpen.value = !isBuyingEnvelopeOpen.value;
};
const toggleBuyingEnvelopeFlipped = () => {
    isBuyingEnvelopeFlipped.value = !isBuyingEnvelopeFlipped.value;
};
const toggleBuyingEnvelopeBackTextOpaque = () => {
    buyingEnvelopeBackTextOpaque.value = !buyingEnvelopeBackTextOpaque.value;
};
const toggleBuyingEnvelopeStampOpaque = () => {
    buyingEnvelopeStampOpaque.value = !buyingEnvelopeStampOpaque.value;
};
const togglebuyingEnvelopeStampBlooming = () => {
    buyingEnvelopeStampBlooming.value = !buyingEnvelopeStampBlooming.value;
};
const toggleBuyingEnvelopeSlid = () => {
    isBuyingEnvelopeSlid.value = !isBuyingEnvelopeSlid.value;
};
const toggleBuyingSentTextHidden = () => {
    buyingSentTextHidden.value = !buyingSentTextHidden.value;
};
const toggleBuyingFailTextHidden = () => {
    buyingFailTextHidden.value = !buyingFailTextHidden.value;
};
const toggleisBuyingEnvelopeSlidFail = () => {
    isBuyingEnvelopeSlidFail.value = !isBuyingEnvelopeSlidFail.value;
};
const setDetailedErrorMessage = (message) => {
    detailedErrorMessage.value = message;
};




const toggleOnEnvelopeSentAnimation = () => {
    stampSrc.value = '/images/theme/stamps/stamp1.webp';
    toggleBuyingVisibility();
    setTimeout(() => {
        toggleBuyingEnvelopeVisibility(); // Run after 2 seconds
    }, 250); // 2000ms = 2 seconds
    setTimeout(() => {
        toggleBuyingEnvelopeOpen(); // Run after 2 seconds
    }, 1000); // 2000ms = 2 seconds
    setTimeout(() => {
        toggleBuyingEnvelopeFlipped(); // Run after 2 seconds
    }, 1750); // 2000ms = 2 seconds
    setTimeout(() => {
        toggleBuyingEnvelopeBackTextOpaque(); // Run after 2 seconds
    }, 2500); // 2000ms = 2 seconds
    setTimeout(() => {
        toggleBuyingEnvelopeStampOpaque(); // Run after 2 seconds
    }, 3000); // 2000ms = 2 seconds
    setTimeout(() => {
        toggleBuyingSentTextHidden();
    }, 3000)
    setTimeout(() => {
        togglebuyingEnvelopeStampBlooming();
    }, 3200)
    setTimeout(() => {
        togglebuyingEnvelopeStampBlooming();
    }, 4000)
    setTimeout(() => {
        toggleBuyingEnvelopeSlid();
    }, 4600)
    // setTimeout(() => {
    //     toggleOffEnvelopeSentAnimation();
    // }, 7500)
}
const toggleOnEnvelopeFailAnimation = (message) => {
    stampSrc.value = '/images/theme/stamps/sendfail.webp';
    setDetailedErrorMessage(message);
    toggleBuyingVisibility();
    setTimeout(() => {
        toggleBuyingEnvelopeVisibility(); // Run after 2 seconds
    }, 250); // 2000ms = 2 seconds
    setTimeout(() => {
        toggleBuyingEnvelopeOpen(); // Run after 2 seconds
    }, 750); // 2000ms = 2 seconds
    setTimeout(() => {
        toggleBuyingEnvelopeFlipped(); // Run after 2 seconds
    }, 1000); // 2000ms = 2 seconds
    setTimeout(() => {
        toggleBuyingEnvelopeBackTextOpaque(); // Run after 2 seconds
    }, 1500); // 2000ms = 2 seconds
    setTimeout(() => {
        toggleBuyingEnvelopeStampOpaque(); // Run after 2 seconds
    }, 2000); // 2000ms = 2 seconds
    setTimeout(() => {
        toggleisBuyingEnvelopeSlidFail();
    }, 2500)
    setTimeout(() => {
        toggleBuyingFailTextHidden();
    }, 3500)
}


const toggleOffEnvelopeSentAnimation = () => {
    toggleBuyingSentTextHidden();
    toggleBuyingEnvelopeVisibility(); // Run after 2 seconds
    toggleBuyingVisibility();
    setTimeout(() => {
        toggleBuyingEnvelopeOpen(); // Run after 2 seconds
        toggleBuyingEnvelopeFlipped(); // Run after 2 seconds
        toggleBuyingEnvelopeBackTextOpaque(); // Run after 2 seconds
        toggleBuyingEnvelopeStampOpaque(); // Run after 2 seconds
        togglebuyingEnvelopeStampBlooming();
        togglebuyingEnvelopeStampBlooming();
        toggleBuyingEnvelopeSlid();
    }, 1000)
}
defineExpose({
    toggleOnEnvelopeSentAnimation,
    toggleOnEnvelopeFailAnimation
});
</script>

<style scoped>
#velocity-form-animation {
    z-index: 120;
}

#envelope-bg {
    background: #ffffff;
}

.envelope-container {
    position: absolute;
    height: 250px;
    width: 250px;
    background: transparent;
    transition: transform 1.8s; /* Smooth flip animation */
    transform-style: preserve-3d; /* Ensures 3D transformation */
    perspective: 1000px;
    z-index: 99;
    border-radius: 2px;
    -ms-border-radius: 2px;
    -moz-border-radius: 2px;
    -o-border-radius: 2px;
    -webkit-border-radius: 2px;

    backface-visibility: hidden;
}
.envelope-container .envelope {
    position: absolute;
    height: 93px;
    width: 165px;
    left: 50%;
    margin-left: -83px;
    top: 50%;
    margin-top: -50px;
    background: #F9F9F9;

    transition: margin-top 600ms;
    -ms-transition: margin-top 600ms;
    -moz-transition: margin-top 600ms;
    -o-transition: margin-top 600ms;
    -webkit-transition: margin-top 600ms;
    backface-visibility: hidden; /* Hides the back side when flipped */
}
.envelope-open .envelope {
    transition-delay: 300ms;
    -ms-transition-delay: 300ms;
    -moz-transition-delay: 300ms;
    -o-transition-delay: 300ms;
    margin-top: -20px;
    border-image: linear-gradient(to bottom right, rgba(0, 0, 0, 0.1), rgba(255, 255, 255, 0.2)) 1;
}
.envelope-container .envelope .top {
    position: absolute;
    top: -3px;
    left: 0px;
    width: 100%;
    height: 73px;
    z-index: 30;
    overflow: hidden;

    transform-origin: top;
    -ms-transform-origin: top;
    -moz-transform-origin: top;
    -o-transform-origin: top;
    -webkit-transform-origin: top;

    transition: transform 600ms 300ms, z-index 0ms 300ms, height 600ms 0ms, top 600ms 0ms;
    -ms-transition: -ms-transform 600ms 300ms, z-index 0ms 300ms, height 600ms 0ms, top 600ms 0ms;
    -moz-transition: -moz-transform 600ms 300ms, z-index 0ms 300ms, height 600ms 0ms, top 600ms 0ms;
    -o-transition: -o-transform 600ms 300ms, z-index 0ms 300ms, height 600ms 0ms, top 600ms 0ms;
    -webkit-transition: -webkit-transform 600ms 300ms, z-index 0ms 300ms, height 600ms 0ms, top 600ms 0ms;
}
.envelope-open .envelope .top {
    transition: transform 600ms 0ms, height 600ms 300ms, top 600ms 300ms;
    -ms-transition: -ms-transform 600ms 0ms, height 600ms 300ms, top 600ms 300ms;
    -moz-transition: -moz-transform 600ms 0ms, height 600ms 300ms, top 600ms 300ms;
    -o-transition: -o-transform 600ms 0ms, height 600ms 300ms, top 600ms 300ms;
    -webkit-transition: -webkit-transform 600ms 0ms, height 600ms 300ms, top 600ms 300ms;

    height: 10px;
    top: -55px;

    transform: rotateX(180deg);
    -ms-transform: rotateX(180deg);
    -moz-transform: rotateX(180deg);
    -o-transform: rotateX(180deg);
    -webkit-transform: rotateX(180deg);
}
.envelope-container .envelope .outer {
    position: absolute;
    bottom: 0px;
    left: 0px;
    border-left: 83px solid transparent;
    border-right: 82px solid transparent;
    border-top: 70px solid #fff;
}
.envelope-container .envelope .outer .inner {
    position: absolute;
    left: -81px;
    top: -73px;
    border-left: 81px solid transparent;
    border-right: 80px solid transparent;
    border-top: 68px solid #748B75;
}
.envelope-container .envelope .bottom {
    position: absolute;
    z-index: 20;
    bottom: 0px;
    left: 2px;
    border-left: 81px solid transparent;
    border-right: 80px solid transparent;
    border-bottom: 45px solid #D5B9B2;
}
.envelope-container .envelope .left {
    position: absolute;
    z-index: 20;
    top: 0px;
    left: 0px;
    border-left: 81px solid #D5B9B2;
    border-top: 45px solid transparent;
    border-bottom: 45px solid transparent;
}
.envelope-container .envelope .right {
    position: absolute;
    z-index: 20;
    top: 0px;
    right: 0px;
    border-right: 80px solid #D5B9B2;
    border-top: 45px solid transparent;
    border-bottom: 45px solid transparent;
}
.envelope-container .envelope .paper {
    position: absolute;
    height: 83px;
    padding-top: 10px;
    width: 100%;
    top: 0px;
    left: 0px;
    background: #F9F9F9;
    z-index: 10;
    transition: margin-top 600ms 0ms;
    -ms-transition: margin-top 600ms 0ms;
    -moz-transition: margin-top 600ms 0ms;
    -o-transition: margin-top 600ms 0ms;
    -webkit-transition: margin-top 600ms 0ms;
}
.envelope-open .envelope .paper {
    margin-top: -60px;
    transition: margin-top 600ms 300ms;
    -ms-transition: margin-top 600ms 300ms;
    -moz-transition: margin-top 600ms 300ms;
    -o-transition: margin-top 600ms 300ms;
    -webkit-transition: margin-top 600ms 300ms;
}
.envelope-container .envelope .paper a.call .i {
    position: absolute;
    top: 1px;
    left: 10px;
    display: inline-block;
    width: 3px;
    height: 5px;
    border-width: 5px 0 5px 2px;
    border-style: solid;
    border-color: #fff;
    background: transparent;

    transform: rotate(-30deg);
    -ms-transform: rotate(-30deg);
    -moz-transform: rotate(-30deg);
    -o-transform: rotate(-30deg);
    -webkit-transform: rotate(-30deg);

    border-top-left-radius: 1.5px 2.5px;
    border-bottom-left-radius: 1.5px 2.5px;
    -moz-border-radius-topleft: 1.5px 2.5px;
    -moz-border-radius-bottomleft: 1.5px 2.5px;
    -webkit-border-top-left-radius: 1.5px 2.5px;
    -webkit-border-bottom-left-radius: 1.5px 2.5px;

    transition: border-color 600ms;
    -ms-transition: border-color 600ms;
    -moz-transition: border-color 600ms;
    -o-transition: border-color 600ms;
    -webkit-transition: border-color 600ms;
}
.envelope-container .envelope .paper a.mail .i {
    position: absolute;
    top: 0px;
    left: 8px;
    display: inline-block;
    font-size: 7px;
    font-weight: bold;
}
/* Back side */
.envelope-back {
    position: absolute;
    height: 93px;
    width: 165px;
    left: 50%;
    margin-left: -83px;
    top: 50%;
    margin-top: -50px;
    background-color: #D5B9B2; /* Blue background */
    transform: rotateY(180deg); /* Initially flipped */

    backface-visibility: hidden;
}
.envelope-container .envelope .paper a {
    position: relative;
    display: block;
    font-size: 7px;
    margin: 5px;
    margin-bottom: 0px;
    text-align: center;
    color: #fff;
    text-decoration: none;
}
.buying-envelope-stamp {
    transition: transform 0.3s ease;
    position: absolute;
    width: 37px;
    top: 5px;
    right: 5px;
}

.sunburst-image {
    width: 38px;
    position: absolute; /* Make the image the reference point for absolute lines */
    top: 0px;
    right: 0px;
    z-index: 1; /* Ensure the image is above the lines */
}

.blooming .line {
    position: absolute;
    top: 11px;
    right: 19px;
    width: 1px; /* Thickness of the lines */
    height: 0; /* Start with no height */
    background: gold; /* Color of the lines */
    transform-origin: top center; /* Grow from the center outward */
    animation: sunburst 0.6s ease 1 forwards;
}
/* Small tablets (768px and up) */
@media (min-width: 768px) {
    .envelope-container {
        position: absolute;
        height: 500px;
        width: 500px;
        background: transparent;
        transition: transform 1.8s; /* Smooth flip animation */
        transform-style: preserve-3d; /* Ensures 3D transformation */
        perspective: 1000px;
        z-index: 99;
        border-radius: 2px;
        -ms-border-radius: 2px;
        -moz-border-radius: 2px;
        -o-border-radius: 2px;
        -webkit-border-radius: 2px;

        backface-visibility: hidden;
    }
    .envelope-container .envelope {
        position: absolute;
        height: 186px;
        width: 330px;
        left: 50%;
        margin-left: -166px;
        top: 50%;
        margin-top: -100px;
        background: #F9F9F9;

        transition: margin-top 600ms;
        -ms-transition: margin-top 600ms;
        -moz-transition: margin-top 600ms;
        -o-transition: margin-top 600ms;
        -webkit-transition: margin-top 600ms;
        backface-visibility: hidden; /* Hides the back side when flipped */
    }
    .envelope-open .envelope {
        transition-delay: 300ms;
        -ms-transition-delay: 300ms;
        -moz-transition-delay: 300ms;
        -o-transition-delay: 300ms;
        margin-top: -20px;
        border-image: linear-gradient(to bottom right, rgba(0, 0, 0, 0.1), rgba(255, 255, 255, 0.2)) 1;
    }
    .envelope-container .envelope .top {
        position: absolute;
        top: -6px;
        left: 0px;
        width: 100%;
        height: 146px;
        z-index: 30;
        overflow: hidden;

        transform-origin: top;
        -ms-transform-origin: top;
        -moz-transform-origin: top;
        -o-transform-origin: top;
        -webkit-transform-origin: top;

        transition: transform 600ms 300ms, z-index 0ms 300ms, height 600ms 0ms, top 600ms 0ms;
        -ms-transition: -ms-transform 600ms 300ms, z-index 0ms 300ms, height 600ms 0ms, top 600ms 0ms;
        -moz-transition: -moz-transform 600ms 300ms, z-index 0ms 300ms, height 600ms 0ms, top 600ms 0ms;
        -o-transition: -o-transform 600ms 300ms, z-index 0ms 300ms, height 600ms 0ms, top 600ms 0ms;
        -webkit-transition: -webkit-transform 600ms 300ms, z-index 0ms 300ms, height 600ms 0ms, top 600ms 0ms;
    }
    .envelope-open .envelope .top {
        transition: transform 600ms 0ms, height 600ms 300ms, top 600ms 300ms;
        -ms-transition: -ms-transform 600ms 0ms, height 600ms 300ms, top 600ms 300ms;
        -moz-transition: -moz-transform 600ms 0ms, height 600ms 300ms, top 600ms 300ms;
        -o-transition: -o-transform 600ms 0ms, height 600ms 300ms, top 600ms 300ms;
        -webkit-transition: -webkit-transform 600ms 0ms, height 600ms 300ms, top 600ms 300ms;

        height: 20px;
        top: -110px;

        transform: rotateX(180deg);
        -ms-transform: rotateX(180deg);
        -moz-transform: rotateX(180deg);
        -o-transform: rotateX(180deg);
        -webkit-transform: rotateX(180deg);
    }
    .envelope-container .envelope .outer {
        position: absolute;
        bottom: 0px;
        left: 0px;
        border-left: 166px solid transparent;
        border-right: 164px solid transparent;
        border-top: 140px solid #fff;
    }
    .envelope-container .envelope .outer .inner {
        position: absolute;
        left: -162px;
        top: -146px;
        border-left: 162px solid transparent;
        border-right: 160px solid transparent;
        border-top: 136px solid #748B75;
    }
    .envelope-container .envelope .bottom {
        position: absolute;
        z-index: 20;
        bottom: 0px;
        left: 4px;
        border-left: 162px solid transparent;
        border-right: 160px solid transparent;
        border-bottom: 90px solid #D5B9B2;
    }
    .envelope-container .envelope .left {
        position: absolute;
        z-index: 20; top: 0px;
        left: 0px;
        border-left: 162px solid #D5B9B2;
        border-top: 90px solid transparent;
        border-bottom: 90px solid transparent;
    }
    .envelope-container .envelope .right {
        position: absolute;
        z-index: 20;
        top: 0px;
        right: 0px;
        border-right: 160px solid #D5B9B2;
        border-top: 90px solid transparent;
        border-bottom: 90px solid transparent;
    }
    .envelope-container .envelope .paper {
        position: absolute;
        height: 166px;
        padding-top: 20px;
        width: 100%;
        top: 0px;
        left: 0px;
        background: #F9F9F9;
        z-index: 10;
        transition: margin-top 600ms 0ms;
        -ms-transition: margin-top 600ms 0ms;
        -moz-transition: margin-top 600ms 0ms;
        -o-transition: margin-top 600ms 0ms;
        -webkit-transition: margin-top 600ms 0ms;
    }
    .envelope-open .envelope .paper {
        margin-top: -120px;
        transition: margin-top 600ms 300ms;
        -ms-transition: margin-top 600ms 300ms;
        -moz-transition: margin-top 600ms 300ms;
        -o-transition: margin-top 600ms 300ms;
        -webkit-transition: margin-top 600ms 300ms;
    }
    .envelope-container .envelope .paper a.call .i {
        position: absolute;
        top: 2px;
        left: 20px;
        display: inline-block;
        width: 6px;
        height: 10px;
        border-width: 5px 0 5px 2px;
        border-style: solid;
        border-color: #fff;
        background: transparent;

        transform: rotate(-30deg);
        -ms-transform: rotate(-30deg);
        -moz-transform: rotate(-30deg);
        -o-transform: rotate(-30deg);
        -webkit-transform: rotate(-30deg);

        border-top-left-radius: 3px 5px;
        border-bottom-left-radius: 3px 5px;
        -moz-border-radius-topleft: 3px 5px;
        -moz-border-radius-bottomleft: 3px 5px;
        -webkit-border-top-left-radius: 3px 5px;
        -webkit-border-bottom-left-radius: 3px 5px;

        transition: border-color 600ms;
        -ms-transition: border-color 600ms;
        -moz-transition: border-color 600ms;
        -o-transition: border-color 600ms;
        -webkit-transition: border-color 600ms;
    }
    .envelope-container .envelope .paper a.mail .i {
        position: absolute;
        top: 0px;
        left: 17px;
        display: inline-block;
        font-size: 13px;
        font-weight: bold;
    }
    /* Back side */
    .envelope-back {
        position: absolute;
        height: 186px;
        width: 330px;
        left: 50%;
        margin-left: -166px;
        top: 50%;
        margin-top: -100px;
        background-color: #D5B9B2; /* Blue background */
        transform: rotateY(180deg); /* Initially flipped */

        backface-visibility: hidden;
    }
    .envelope-container .envelope .paper a {
        position: relative;
        display: block;
        font-size: 14px;
        margin: 10px;
        margin-bottom: 0px;
        text-align: center;
        color: #fff;
        text-decoration: none;
    }
    .buying-envelope-stamp {
        transition: transform 0.3s ease;
        position: absolute;
        width: 75px;
        top: 10px;
        right: 10px;
    }

    .sunburst-image {
        width: 75px;
        position: absolute; /* Make the image the reference point for absolute lines */
        top: 0px;
        right: 0px;
        z-index: 1; /* Ensure the image is above the lines */
    }

    .blooming .line {
        position: absolute;
        top: 22px;
        right: 37px;
        width: 2px; /* Thickness of the lines */
        height: 0; /* Start with no height */
        background: gold; /* Color of the lines */
        transform-origin: top center; /* Grow from the center outward */
        animation: sunburst 0.6s ease 1 forwards;
    }
}

.flip-inner {
    position: relative;
    width: 100%;
    height: 100%;
    text-align: center;
    transition: transform 1.8s; /* Smooth flip animation */
    transform-style: preserve-3d; /* Ensures 3D transformation */
}
/* Flip on hover */
.envelope-container.envelope-flipped .flip-inner {
    transform: rotateY(180deg); /* Rotate 180 degrees on the Y-axis */
}
.envelope-container .envelope .cover {
    position: absolute;
    z-index: 15;
    bottom: 0px;
    left: 0px;
    height: 55%;
    width: 100%;
    background: #fff;
}
.envelope-container .envelope .paper a {
    color: #fff;

    transition: color 400ms;
    -ms-transition: color 400ms;
    -moz-transition: color 400ms;
    -o-transition: color 400ms;
    -webkit-transition: color 400ms;
}
.envelope-container .envelope .paper a:hover {
    color: #fff;
}
.envelope-container .envelope .paper a.call:hover .i {
    border-color: #fff;
}
.envelope-back.envelope-flipped .paper {
    opacity: 1;
}
.envelope-back.envelope-flipped .inner {
    opacity: 0;
}
.buying-envelope-stamp.stamped {
    animation: stampBounce 1.0s ease;
}
@keyframes stampBounce {
    0% {
        transform: scale(1) translateY(0);
    }
    25% {
        transform: scale(1.03) translateY(-4px); /* Faster scale up and move up */
    }
    50% {
        transform: scale(0.98) translateY(2px); /* Faster scale down and move down */
    }
    75% {
        transform: scale(1.01) translateY(-2px); /* Slightly scale up and move up */
    }
    100% {
        transform: scale(1) translateY(0); /* Snap back to original state */
    }
}
.sunburst-container {
    /* No relative or inline-block here */
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%; /* Adjust as needed */
    height: 100%; /* Adjust as needed */
}


/* Define rotation angles for 8 lines */
.blooming  .line-1 { transform: translate(50%, 0%) rotate(0deg); }
.blooming  .line-2 { transform: translate(100%, 0%) rotate(45deg); }
.blooming  .line-3 { transform: translate(50%, 0%) rotate(90deg); }
.blooming .line-4 { transform: translate(100%, 0%) rotate(135deg); }
.blooming .line-5 { transform: translate(50%, 0%) rotate(180deg); }
.blooming .line-6 { transform: translate(100%, 0%) rotate(225deg); }
.blooming .line-7 { transform: translate(50%, 0%) rotate(270deg); }
.blooming .line-8 { transform: translate(100%, 0%) rotate(315deg); }


@keyframes sunburst {
    0% {
        height: 0; /* Start with no height */
        opacity: 1;
    }
    50% {
        height: 55px; /* Maximum height of the lines */
        opacity: 1;
    }
    100% {
        height: 0; /* Collapse back to no height */
        opacity: 0;
    }
}
.envelope-slide {
    animation: slideRight 0.5s cubic-bezier(0.4, 0, 0.2, 1) forwards;
}
@keyframes slideRight {
    0% {
        transform: translateX(0); /* Start at original position */
    }
    100% {
        transform: translateX(150%); /* Move to the right */
    }
}
@keyframes slideRightFail {
    0% {
        transform: translateX(0) rotate(0); /* Start at original position */
    }
    50% {
        transform: translateX(50%) rotate(10deg); /* Slide to the right and tilt */
    }
    60% {
        transform: translateX(40%) rotate(-10deg); /* Wiggle back slightly */
    }
    70% {
        transform: translateX(50%) rotate(10deg); /* Wiggle forward */
    }
    80% {
        transform: translateX(40%) rotate(-10deg); /* Wiggle back again */
    }
    90% {
        transform: translateX(50%) rotate(10deg); /* Final wiggle forward */
    }
    100% {
        transform: translateX(0) rotate(0) rotateX(90deg); /* Return to start and fall backward */
    }
}
.slideRightFail {
    animation: slideRightFail 1s ease-in-out forwards;
    transform-origin: bottom center;
}

</style>
